import script from "./PaginationDots.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationDots.vue?vue&type=script&setup=true&lang=ts"

import "./PaginationDots.vue?vue&type=style&index=0&id=609d4515&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609d4515"]])

export default __exports__